import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { Link, Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apiClient from '../../utils/api-client';
import { register } from './../../services/userServices';
import PageHeader from './../Common/PageHeader';
import './RegisterPage.css';
const RegisterPage = () => {
  const [cities, setCities] = useState([]);
  const [error, setError] = useState('');
  const {
    register: formRegister,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const onSubmit = (formData) => {
    register(formData)
      .then((response) => {
        if (response && response.data.status === false) {
          // Handle validation errors
          const errorMessages = response.data.data.map((error) => {
            return error;
          });
          toast.error(errorMessages.join(', '));
        } else if (response && response.data.status === true) {
          toast.success('Registration successful');
          setRegistrationSuccess(true);
        } else {
          // Handle other responses or errors
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        // Handle network errors or other unexpected errors
        toast.error('An error occurred while registering.');
      });
  };
  useEffect(() => {
    apiClient
      .get('/city')
      .then((res) => {
        setCities(res.data.data);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, []);
  if (registrationSuccess) {
    return <Navigate to="/login" />;
  }
  return (
    <>
      <Helmet>
        <title>
          Do you want to get Notice of new Arrivals? Signup on Bakumia
        </title>
        <meta
          name="keywords"
          content="new unique items,creative items for home,creative home decor items,creative decorative items,creative products to sell online,creative memories items for sale,creative gift supplies,creative item for home and office,unique products for home,unique home products,unique office wall decor,interesting home products,unique decorative pieces,unique home essentials,funky home decor items,unique home decorative items,unique home office decor,unique household gadgets"
        />
        <meta
          name="description"
          content="If You don`t have account on bakumia.pk, then don`t loss the opportunity of getting notification of new arrivals so just signup your account and login with your own account "
        />
      </Helmet>

      <PageHeader title="Registration" />
      <div className="container-fluid">
        <div className="row py-3">
          {/* ===== Left Side Content ===== */}
          <div className="col-lg-6 d-lg-block d-none">
            <h3 className="fw-bold">Bakumia.pk</h3>
            <hr className="w-header" />
            <p className="lead w-responsive mx-auto text-muted mt-4 pt-2 mb-5 pe-5">
              To get notification of new arrival of home and kitchen products,
              it is necessary to have an account on Bakumia.pk so that we can
              update you with new arrivals timely and you may avail the chance
              of shopping for products as soon as possible.
            </p>
            <div className="bg-image__register" />
          </div>

          {/* ===== Right Side Form ===== */}
          <section className="col-lg-6 d-flex justify-content-center align-items-center">
            <div className="card shadow-lg w-100">
              {/* Form Card */}
              <div className="card-body p-4 p-md-5">
                <h1 className="fs-4 card-title fw-bold mb-4">Register</h1>

                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* Name + Email */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6 col-12">
                      <label htmlFor="full_name" className="mb-2 text-muted">
                        Name
                      </label>
                      <input
                        id="full_name"
                        type="text"
                        className="form-control"
                        placeholder="user name"
                        {...formRegister('full_name', {
                          required: true,
                          minLength: 3,
                          maxLength: 30,
                        })}
                      />
                      {errors.full_name?.type === 'required' && (
                        <span className="form_error">
                          Please enter your name.
                        </span>
                      )}
                      {errors.full_name?.type === 'minLength' && (
                        <span className="form_error">
                          Name should be at least 3 characters.
                        </span>
                      )}
                      {errors.full_name?.type === 'maxLength' && (
                        <span className="form_error">
                          Name should be less than 30 characters.
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 col-12">
                      <label htmlFor="email" className="mb-2 text-muted">
                        Email
                      </label>
                      <input
                        id="email"
                        type="email"
                        className="form-control"
                        placeholder="example@example.com"
                        autoComplete="username"
                        {...formRegister('email', {
                          required: true,
                          maxLength: 50,
                        })}
                      />
                      {errors.email?.type === 'required' && (
                        <span className="form_error">
                          Please enter your email.
                        </span>
                      )}
                      {errors.email?.type === 'maxLength' && (
                        <span className="form_error">
                          Email should be less than 50 characters.
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Phone + Password */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6 col-12">
                      <label htmlFor="phone" className="mb-2 text-muted">
                        Phone Number
                      </label>
                      <input
                        id="phone"
                        type="number"
                        className="form-control"
                        placeholder="03121212112"
                        {...formRegister('phone', {
                          required: true,
                          minLength: 11,
                          maxLength: 11,
                        })}
                      />
                      {errors.phone?.type === 'required' && (
                        <span className="form_error">
                          Please enter your phone number.
                        </span>
                      )}
                      {errors.phone?.type === 'minLength' && (
                        <span className="form_error">
                          Phone number must be 11 characters.
                        </span>
                      )}
                      {errors.phone?.type === 'maxLength' && (
                        <span className="form_error">
                          Phone number exceed 11 characters.
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 col-12">
                      <label htmlFor="password" className="mb-2 text-muted">
                        Password
                      </label>
                      <input
                        id="password"
                        type="password"
                        className="form-control"
                        placeholder="enter password"
                        autoComplete="current-password"
                        {...formRegister('password', {
                          required: true,
                          minLength: 6,
                        })}
                      />
                      {errors.password?.type === 'required' && (
                        <span className="form_error">
                          Please enter your password.
                        </span>
                      )}
                      {errors.password?.type === 'minLength' && (
                        <span className="form_error">
                          Password should be at least 6 characters.
                        </span>
                      )}
                    </div>
                  </div>

                  {/* City + Referral */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6 col-12">
                      <label htmlFor="city" className="mb-2 text-muted">
                        City
                      </label>
                      <select
                        id="c_country"
                        className="form-control"
                        {...formRegister('city', { required: true })}
                      >
                        <option value="">Select City</option>
                        {cities?.map((city) => (
                          <option key={city.city_id} value={city.city_id}>
                            {city.city_name}
                          </option>
                        ))}
                      </select>
                      {errors.city?.type === 'required' && (
                        <span className="form_error">
                          Please enter your city.
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 col-12">
                      <label
                        htmlFor="referral_code"
                        className="mb-2 text-muted"
                      >
                        Referral Code
                      </label>
                      <input
                        id="referral_code"
                        type="text"
                        className="form-control"
                        placeholder="12345"
                        {...formRegister('referral_code', {
                          maxLength: 50,
                        })}
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="mb-3">
                    <label htmlFor="address" className="mb-2 text-muted">
                      Address
                    </label>
                    <input
                      id="address"
                      type="text"
                      className="form-control"
                      placeholder="123 Main St"
                      {...formRegister('address', {
                        required: true,
                        maxLength: 100,
                      })}
                    />
                    {errors.address?.type === 'required' && (
                      <span className="form_error">
                        Please enter your address.
                      </span>
                    )}
                    {errors.address?.type === 'maxLength' && (
                      <span className="form_error">
                        Address should be less than 100 characters.
                      </span>
                    )}
                  </div>

                  {/* Policy */}
                  <p className="form-text text-muted mb-3">
                    By registering you agree with our{' '}
                    <Link to="/privacy-policy/" className="purple__color">
                      Privacy Policy
                    </Link>{' '}
                    and{' '}
                    <Link to="/terms-and-conditions/" className="purple__color">
                      Terms and Conditions
                    </Link>
                    .
                  </p>

                  {/* Submit Button */}
                  <div className="d-flex align-items-center">
                    <button
                      type="submit"
                      className="p-2 button border-0 w-100 mt-2"
                    >
                      Register
                    </button>
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="card-footer py-3 border-0">
                <div className="text-center">
                  Already have an account?{' '}
                  <Link
                    to="/login"
                    className="text-decoration-underline purple__color"
                  >
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
export default RegisterPage;
